/**
 * While hurt: under a third of their health, and still standing.
 *
 * Deliberately not "while downed". A perk that only pays out once someone is on the floor rewards
 * losing, and this one rewards the fight just before that.
 */

import type { EffectCondition } from '@/sim/effects/effectConditionContract';

/** Health fraction at or below which a character counts as hurt. */
export const HURT_THRESHOLD = 1 / 3;

export const WHILE_HURT = {
  id: 'whileHurt',
  label: 'while hurt',
  holds: (moment) => !moment.downed && moment.healthFraction <= HURT_THRESHOLD,
} as const satisfies EffectCondition;
